// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__PaYv5","pink":"About_pink__GM6s-","green":"About_green__qFOAI","skills":"About_skills__EYNpJ"};